export default function app_params(state = null, action) {
    switch (action.type) {
        case 'APP_PARAMS_SET':
            return { ...(state || {}), ...action.payload }
        default:
            return state
    }
} 